var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { MUTUAL_FUNDS_MANDATE_TRANSACTIONS_CLEAR_ALL_FILTERS, MUTUAL_FUNDS_MANDATE_TRANSACTIONS_ERROR, MUTUAL_FUNDS_MANDATE_TRANSACTIONS_HIDE_ERROR, MUTUAL_FUNDS_MANDATE_TRANSACTIONS_RESET_ALL_FILTERS_AND_SEARCH, MUTUAL_FUNDS_MANDATE_TRANSACTIONS_UPDATE_FILTERS, MUTUAL_FUNDS_MANDATE_TRANSACTIONS_UPDATE_INITIAL_DATA, } from "../interface/IMutualFundsMandateTransactions";
import { EFilterType, updatedFilter } from "@domains/utils/filter";
import { searchMultipleKeys } from "@domains/utils/search";
import moment from "moment";
export var mandateTransactionInitialData = {
    errorData: {
        error: undefined,
        isOpen: false,
    },
    appliedFilters: {
        filteredData: {
            dpDate: {
                fromDate: {
                    keyName: "dpDate",
                    filterValue: moment().startOf("month").format("YYYY-MM-DD"),
                    type: EFilterType.Date,
                },
                toDate: {
                    keyName: "dpDate",
                    filterValue: moment().format("YYYY-MM-DD"),
                    type: EFilterType.Date,
                },
            },
        },
        searchText: "",
    },
    initialMandateData: undefined,
    filteredData: undefined,
};
var mutualFundsMandateTransactionsReducer = function (state, action) {
    var _a, _b, _c;
    if (state === void 0) { state = JSON.parse(JSON.stringify(mandateTransactionInitialData)); }
    switch (action.type) {
        case MUTUAL_FUNDS_MANDATE_TRANSACTIONS_ERROR:
            return __assign(__assign(__assign({}, state), mandateTransactionInitialData), { errorData: action.payload.errorData });
        case MUTUAL_FUNDS_MANDATE_TRANSACTIONS_HIDE_ERROR:
            return __assign(__assign({}, state), { errorData: mandateTransactionInitialData.errorData });
        case MUTUAL_FUNDS_MANDATE_TRANSACTIONS_UPDATE_FILTERS:
            return __assign(__assign({}, state), { appliedFilters: action.payload.appliedFilters, filteredData: __assign(__assign({}, state === null || state === void 0 ? void 0 : state.initialMandateData), { lst: handleUpdateFilterData(action.payload.appliedFilters, (_a = state === null || state === void 0 ? void 0 : state.initialMandateData) === null || _a === void 0 ? void 0 : _a.lst) }) });
        case MUTUAL_FUNDS_MANDATE_TRANSACTIONS_CLEAR_ALL_FILTERS:
            var localAppliedFilters = __assign(__assign({}, state.appliedFilters), { filteredData: {
                    dpDate: state.appliedFilters.filteredData.dpDate,
                }, searchText: state.appliedFilters.searchText });
            return __assign(__assign({}, state), { appliedFilters: localAppliedFilters, filteredData: __assign(__assign({}, state === null || state === void 0 ? void 0 : state.initialMandateData), { lst: handleUpdateFilterData(localAppliedFilters, (_b = state === null || state === void 0 ? void 0 : state.initialMandateData) === null || _b === void 0 ? void 0 : _b.lst) }) });
        case MUTUAL_FUNDS_MANDATE_TRANSACTIONS_RESET_ALL_FILTERS_AND_SEARCH:
            return __assign(__assign({}, state), { appliedFilters: __assign(__assign({}, state.appliedFilters), { searchText: "", filteredData: mandateTransactionInitialData.appliedFilters.filteredData }), filteredData: (state === null || state === void 0 ? void 0 : state.initialMandateData) &&
                    JSON.parse(JSON.stringify(state.initialMandateData)) });
        case MUTUAL_FUNDS_MANDATE_TRANSACTIONS_UPDATE_INITIAL_DATA:
            return __assign(__assign({}, state), { initialMandateData: JSON.parse(JSON.stringify(action.payload.initialDataFromAPI)), filteredData: {
                    lst: handleUpdateFilterData(state === null || state === void 0 ? void 0 : state.appliedFilters, (_c = action.payload.initialDataFromAPI) === null || _c === void 0 ? void 0 : _c.lst),
                } });
        default:
            return __assign({}, state);
    }
};
export default mutualFundsMandateTransactionsReducer;
var handleUpdateFilterData = function (filterPayload, initialData) {
    var localData = __spreadArray([], __read(initialData), false);
    if (filterPayload.searchText) {
        localData = searchMultipleKeys(localData, ["bankName", "mandateId", "clientName", "mandateType", "pan", "dpStatus"], filterPayload.searchText);
    }
    if ((filterPayload === null || filterPayload === void 0 ? void 0 : filterPayload.filteredData) &&
        Object.keys(filterPayload === null || filterPayload === void 0 ? void 0 : filterPayload.filteredData).length) {
        localData = updatedFilter(localData, createRequiredFilterFormat(filterPayload === null || filterPayload === void 0 ? void 0 : filterPayload.filteredData));
    }
    return localData;
};
var createRequiredFilterFormat = function (data) {
    var formattedFilters = [];
    Object.keys(data).forEach(function (key) {
        var tempValue = [];
        var typeOfFilter = undefined;
        Object.keys(data[key]).forEach(function (key2) {
            var filterObj = data[key][key2];
            var subFilterKeys = !!(filterObj === null || filterObj === void 0 ? void 0 : filterObj.subListFiltersValues)
                ? Object.keys(filterObj === null || filterObj === void 0 ? void 0 : filterObj.subListFiltersValues)
                : [];
            if (subFilterKeys === null || subFilterKeys === void 0 ? void 0 : subFilterKeys.length) {
                subFilterKeys.forEach(function (item) {
                    tempValue.push(item);
                });
            }
            else {
                tempValue.push(filterObj === null || filterObj === void 0 ? void 0 : filterObj.filterValue);
            }
            typeOfFilter = filterObj === null || filterObj === void 0 ? void 0 : filterObj.type;
        });
        formattedFilters.push(__assign({ key: key, value: !!typeOfFilter && typeOfFilter === EFilterType.Date
                ? tempValue.length > 1 &&
                    "".concat(moment(tempValue[0]).format("DD MMM YY"), " to ").concat(moment(tempValue[1]).format("DD MMM YY"))
                : tempValue }, (!!typeOfFilter && { type: typeOfFilter })));
    });
    return formattedFilters;
};
